import axios from 'axios'
import store from '../store'

export default {
    methods: {
        OpenSocket(printdoc){
            var socket;
            socket = new WebSocket(this.TicketPrintWSocket);
            socket.onopen = function (event) {
                console.log("Open");
               socket.send(printdoc);
            };
            socket.onerror = this.updateState();
            socket.onclose = function (event) {
                console.log("Closed");
            };
            socket.onmessage = function (event) {
                console.log("Closing");
                socket.close(1000, "Closing from client");
            };
        },
        updateState(socket) {
            
            if (!socket) {
                console.log('no socket')
            } else {
                switch (socket.readyState) {
                    case WebSocket.CLOSED:
                        console.log("Closed");
                        break;
                    case WebSocket.CLOSING:
                        console.log("Closing");
                        break;
                    case WebSocket.CONNECTING:
                        console.log("Connecting");
                        break;
                    case WebSocket.OPEN:
                        console.log("Open");
                        break;
                    default:
                        console.log("Nada");
                        break;
                }
            }
        }
    }
}